var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('b-dropdown-item',{on:{"click":_vm.createItem}},[_c('feather-icon',{staticClass:"mr-50",attrs:{"icon":"LayersIcon"}}),_c('span',[_vm._v("duplicate")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }